import { useAuth } from '../context/AuthContext';
import { useState } from 'react';
import {
  FiMenu,
  FiX,
  FiLogOut,
  FiTool,
  FiShoppingCart,
  FiImage,
  FiUsers,
  FiShare2,
  FiGrid,
  FiHome,
} from 'react-icons/fi';
import AdminServices from './Admin/AdminServices';
import AdminGallery from './Admin/AdminGallery';
import AdminClients from './Admin/AdminClients';
import AdminSocialMedia from './Admin/AdminSocialMedia';
import AdminEcosystem from './Admin/AdminEcosystem';
import AdminDashboardHome from './Admin/AdminDashboardHome';

const AdminDashboard = () => {
  const { user, logout } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [activeTab, setActiveTab] = useState('home');

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
      console.error('Error al cerrar sesión:', error);
    }
  };

  const menuItems = [
    {
      id: 'home',
      label: 'Inicio',
      icon: FiHome,
      color: 'bg-blue-500/20 hover:bg-blue-500/30 text-blue-600 dark:text-blue-400',
    },
    {
      id: 'services',
      label: 'Servicios',
      icon: FiTool,
      color: 'bg-green-500/20 hover:bg-green-500/30 text-green-600 dark:text-green-400',
    },
    {
      id: 'gallery',
      label: 'Galería',
      icon: FiImage,
      color: 'bg-purple-500/20 hover:bg-purple-500/30 text-purple-600 dark:text-purple-400',
    },
    {
      id: 'clients',
      label: 'Logos Clientes',
      icon: FiUsers,
      color: 'bg-orange-500/20 hover:bg-orange-500/30 text-orange-600 dark:text-orange-400',
    },
    {
      id: 'social',
      label: 'Redes Sociales',
      icon: FiShare2,
      color: 'bg-pink-500/20 hover:bg-pink-500/30 text-pink-600 dark:text-pink-400',
    },
    {
      id: 'ecosystem',
      label: 'Empresas',
      icon: FiGrid,
      color: 'bg-indigo-500/20 hover:bg-indigo-500/30 text-indigo-600 dark:text-indigo-400',
    },
  ];

  const renderContent = () => {
    switch (activeTab) {
      case 'services':
        return <AdminServices />;
      case 'gallery':
        return <AdminGallery />;
      case 'clients':
        return <AdminClients />;
      case 'social':
        return <AdminSocialMedia />;
      case 'ecosystem':
        return <AdminEcosystem />;
      default:
        return <AdminDashboardHome />;
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-slate-100 dark:from-slate-950 dark:to-slate-900">
      {/* Header */}
      <header className="sticky top-0 z-40 bg-white dark:bg-slate-900 border-b border-slate-200 dark:border-slate-700 shadow-sm">
        <div className="flex items-center justify-between px-4 md:px-6 py-4">
          <div className="flex items-center gap-4">
            <button
              onClick={() => setSidebarOpen(!sidebarOpen)}
              className="md:hidden p-2 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-lg"
            >
              {sidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
            </button>
            <h1 className="text-xl font-bold text-slate-900 dark:text-white">
              Panel Administrativo
            </h1>
          </div>
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2 px-3 py-2 bg-slate-100 dark:bg-slate-800 rounded-lg">
              <div className="w-2 h-2 bg-green-500 rounded-full" />
              <span className="text-sm text-slate-600 dark:text-slate-300 truncate max-w-xs">
                {user?.email}
              </span>
            </div>
            <button
              onClick={handleLogout}
              className="p-2 hover:bg-red-100 dark:hover:bg-red-950 text-red-600 dark:text-red-400 rounded-lg transition-colors"
              title="Cerrar sesión"
            >
              <FiLogOut size={20} />
            </button>
          </div>
        </div>
      </header>

      <div className="flex h-[calc(100vh-73px)]">
        {/* Sidebar */}
        <aside
          className={`
            fixed md:relative left-0 top-0 h-full z-30 
            w-64 bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-700
            transform transition-transform duration-300 md:translate-x-0
            ${sidebarOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
            overflow-y-auto
          `}
          style={{ marginTop: '73px' }}
        >
          <nav className="p-4 space-y-2">
            {menuItems.map((item) => {
              const Icon = item.icon;
              const isActive = activeTab === item.id;
              return (
                <button
                  key={item.id}
                  onClick={() => {
                    setActiveTab(item.id);
                    setSidebarOpen(false);
                  }}
                  className={`
                    w-full flex items-center gap-3 px-4 py-3 rounded-lg font-medium
                    transition-all duration-200
                    ${
                      isActive
                        ? 'bg-slate-900 dark:bg-slate-700 text-white shadow-lg'
                        : `${item.color}`
                    }
                  `}
                >
                  <Icon size={20} />
                  <span>{item.label}</span>
                </button>
              );
            })}
          </nav>
        </aside>

        {/* Main Content */}
        <main className="flex-1 overflow-auto">
          <div className="p-4 md:p-6">{renderContent()}</div>
        </main>
      </div>

      {/* Overlay móvil */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-20 md:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}
    </div>
  );
};

export default AdminDashboard;
